<crm-drawer #drawer>
  <crm-task-queue></crm-task-queue>
  <crm-list-objects-page
    [objectType]="objectType"
    [activityType]="activityType"
    [customRowStyle]="customRowStyle"
    [multiActions]="multiRowActions$ | async"
    [singleActions]="singleRowActions$ | async"
    [presetFilters]="presetFilters$ | async"
    [refreshRow$]="refreshRow$"
    (editClick)="handleEditTaskClick($event)"
    (selectionChange)="handleRowsChange($event)"
  >
    <ng-container crmTableContent="page-actions">
      <ng-container *ngIf="tableRows() as tableRows">
        <button mat-stroked-button (click)="handleStartTaskQueueClick()">
          @if (hasAccessToFeature$ | async) {
            <mat-icon>play_arrow</mat-icon>
          } @else {
            <mat-icon>lock</mat-icon>
          }
          {{ 'TASK.LIST_OBJECTS_TABLE.ACTIONS.TASK_QUEUE.START_COUNT' | translate: { count: tableRows.length || '0' } }}
        </button>
      </ng-container>
      @if (!isMultiLocation()) {
        <button mat-flat-button color="primary" (click)="handleCreateTaskClick()">
          {{ 'TASK.LIST_OBJECTS_TABLE.ACTIONS.CREATE.TITLE' | translate }}
        </button>
      }
    </ng-container>
  </crm-list-objects-page>
</crm-drawer>

<ng-template #upsert>
  <div class="drawer-container">
    @switch (activityLoadError$ | async) {
      @case (TaskError.NO_ERROR) {
        <ng-container *ngTemplateOutlet="upsertBody; context: { activity: activity$ | async }"></ng-container>
      }
      @case (TaskError.UNKNOWN_ERROR) {
        <p>{{ 'TASK.LIST_OBJECTS_TABLE.ACTIONS.EDIT.ERROR_LOADING_TASK' | translate }}</p>
      }
      @case (TaskError.ACCESS_DENIED) {
        <ng-container *ngTemplateOutlet="permissionRequired"></ng-container>
      }
    }
  </div>
</ng-template>

<ng-template #permissionRequired>
  <crm-permission-required-panel></crm-permission-required-panel>
</ng-template>

<ng-template #upsertBody let-activity="activity">
  <crm-activity-logger-task
    mobile
    [activity]="activity"
    [activityOwner]="activityOwner$ | async"
    [user]="user$ | async"
    [(associations)]="otherAssociations"
  >
    <ng-container crmLoggerContent="fields">
      <ng-container
        *ngTemplateOutlet="associationFormRow; context: { namespace: activity?.namespace ?? '' }"
      ></ng-container>
    </ng-container>
  </crm-activity-logger-task>
  <div class="drawer-actions">
    <button
      mat-flat-button
      color="primary"
      type="button"
      [disabled]="taskWorkState.isLoading$ | async"
      (click)="handleSaveClick(!activity ? 'create' : 'edit')"
    >
      <glxy-button-loading-indicator [isLoading]="(taskWorkState.isLoading$ | async) === true">
        <ng-container *ngIf="!activity; else editTaskButton">
          {{ 'TASK.LIST_OBJECTS_TABLE.ACTIONS.CREATE.TITLE' | translate }}
        </ng-container>
        <ng-template #editTaskButton>
          {{ 'TASK.LIST_OBJECTS_TABLE.ACTIONS.EDIT.TITLE' | translate }}
        </ng-template>
      </glxy-button-loading-indicator>
    </button>
    <button mat-stroked-button type="button" (click)="handleCancelClick()">
      {{ 'ACTIONS.CANCEL' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #associationFormRow let-namespace="namespace">
  <glxy-form-row>
    <glxy-form-field class="association-field" [prefixIcon]="'person'" bottomSpacing="small">
      <crm-contact-to-company-association-form-field
        insideInputWrapper
        [namespace]="namespace"
        [(associations)]="contactAssociations"
        mobile
        [placeholder]="'ACTIVITY_LOGGER.ADD_CONTACT_ASSOCIATION' | translate"
      ></crm-contact-to-company-association-form-field>
    </glxy-form-field>
  </glxy-form-row>
  @if (!isMultiLocation()) {
    <glxy-form-row>
      <glxy-form-field class="association-field" [prefixIcon]="'domain'" bottomSpacing="small">
        <crm-company-association-form-field
          insideInputWrapper
          [(associations)]="companyAssociations"
          mobile
          [placeholder]="'ACTIVITY_LOGGER.ADD_COMPANY_ASSOCIATION' | translate"
        ></crm-company-association-form-field>
      </glxy-form-field>
    </glxy-form-row>
  }
</ng-template>
